<template>
	<vs-popup
		:active.sync="activeProp"
		:title="$t('infoAboutAuthor')"
	>
		<div class="row">
			{{ $t('fioAuthor') }}: <strong>{{ author.first_name}} {{ author.last_name}}</strong>
		</div>
		<div class="row">
			{{ $t('emailAuthor') }}: <strong>{{ author.email}}</strong>
		</div>
		<div class="row" 					
			v-if="userRole === 'admin'"
		>
			<strong>
				<RouterLink :to="`/${pathToAuthor}/${author.id}`" class="order-author__link" target="_blank">
					{{ $t('urlProfileAuthor') }}
				</RouterLink>
			</strong>
		</div>
		<br>
		<div class="row">
			{{ $t('fioAliasAuthor') }}: <strong>{{ author.username}}</strong>
		</div>
		<div class="row">
			{{ $t('emailAliasAuthor') }}: <strong>{{ author.emailAuthor}}@{{ website }}</strong>
		</div>
		<br>
		<div class="row">
			{{ $t('subjects') }}: <strong>{{ subjects }}</strong>
		</div>
		<br>
		<div class="row">
			{{ $t('activeOrderAuthor') }}: <strong v-html="author.listOrder"></strong>
		</div>
        <div class="set-ticket-done__controls">    
			<vs-button
				@click="close"
				color="#9a9a9a"
				type="flat"
			>{{ $t('close') }}</vs-button>
		</div>
	</vs-popup>
</template>

<script>
export default {
	name: "ViewOrderAuthorCart",
	props: {
		active: { required: true, type: Boolean },
		author: { required: true },
		website: { required: true },
		subjects: { required: true },
	},
	data() {
		return {
			authorOrder: { },
		}
	},
    components: {
    },
    watch: { 
		activeProp(newValue) {
			if(newValue === false) {
				this.reward = 0;
			}
		}
	},
	computed: {
		pathToAuthor() {
			const role = this.$store.state.auth.role;
			if(role === "admin") {
				return "author";
			} else if(role === "manager") {
				return "authorM";
			}

			return "";
		},
		userRole() {
			return this.$store.state.auth.role;
		},
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		}
	},
	methods: {
        close() {
			this.activeProp = false;
		},
	},
};
</script>

<style scoped lang="scss">
	
</style>